import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';

const InfoSuiviColis = ({ urlSuiviColis, urlPreuveLivraison, urlSuiviColisDetaille, afficheSuiviColisDetaille }) => (
    <React.Fragment>
        {(urlSuiviColis || urlPreuveLivraison || urlSuiviColisDetaille) &&
            <Typography>
                {urlSuiviColis && <a target="_blank" href={urlSuiviColis} rel="noopener noreferrer">Suivi colis</a>}
                {urlSuiviColis && urlPreuveLivraison && <span>&nbsp;-&nbsp;</span>}
                {urlPreuveLivraison && <a target="_blank" href={urlPreuveLivraison} rel="noopener noreferrer">Preuve de livraison</a>}
                {(urlSuiviColis || urlPreuveLivraison) && afficheSuiviColisDetaille && <br/>}
                {afficheSuiviColisDetaille && urlSuiviColisDetaille && <a target="_blank" href={urlSuiviColisDetaille} rel="noopener noreferrer">Suivi colis detaillé</a>}

            </Typography>
        }
    </React.Fragment>
);

InfoSuiviColis.propTypes = {
    urlPreuveLivraison: PropTypes.string,
    urlSuiviColis: PropTypes.string,
    urlSuiviColisDetaille: PropTypes.string,
    afficheSuiviColisDetaille: PropTypes.bool.isRequired
};

export default InfoSuiviColis;